var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 31,
    viewBox: "0 0 30 31",
    width: 30,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4F48F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 2.89136c-3.275 0-5.9375 2.65738-5.9375 5.92608 0 3.20636 2.5125 5.80136 5.7875 5.91356.1-.0124.2-.0124.275 0h.0625.025c3.2-.1122 5.7125-2.7072 5.725-5.91356 0-3.2687-2.6625-5.92608-5.9375-5.92608z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.3502 18.0497c-3.4875-2.3205-9.175-2.3205-12.6875 0-1.5875 1.0605-2.4625 2.4952-2.4625 4.0298 0 1.5345.875 2.9568 2.45 4.0047 1.75 1.1728 4.05 1.7592 6.35 1.7592s4.6-.5864 6.35-1.7592c1.575-1.0604 2.45-2.4827 2.45-4.0297-.0125-1.5345-.875-2.9568-2.45-4.0048z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.65b2a8c1ff75e6dca8b221a0db40cde8.svg";
export { ForwardRef as ReactComponent };